export default function CVariables() {
  return <h2>C Variables</h2>;
}
